/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { RestoreSessionDto } from '../dtos/RestoreSessionDto';
import { useAuthApi } from '../hooks/useAuthApi';
import { useAuthCtx } from '../hooks/useAuthCtx';
import { useInterval } from '../hooks/useInterval';
import { useSessionInfoStorage } from '../hooks/useSessionInfoStorage';
import { ErrorCodes } from '../model/ErrorCodes.enum';
interface IProps {}

const DELAY = 60000 * 15; // quinze minutos;
const INITIAL_DELAY = 5000; // Aguardar 5 segundos antes do primeiro refresh (evita restore muito cedo)
const SESSION_REFRESH_CHANNEL = 'session-refresh-channel';

/**
 * Fica fazendo restore da sessao para atualizar o seu ttl e verificar se usuario
 * ainda tem sessao ativa.
 *
 * Coordenação entre abas: apenas uma aba (master) faz o refresh para evitar
 * múltiplas requisições simultâneas e garantir que o intervalo funcione corretamente.
 */
export const SessionRefresher: React.FC<IProps> = ({}) => {
  const { session, auth0_token: auth0_access_token, logout } = useAuthCtx();
  const session_persistence = useSessionInfoStorage();
  const session_info = session_persistence.get();
  const { restore } = useAuthApi();

  const [isMasterTab, setIsMasterTab] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const channelRef = useRef<BroadcastChannel | null>(null);
  const masterTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const initialDelayRef = useRef<NodeJS.Timeout | null>(null);
  const hasActiveMasterRef = useRef(false);

  // Aguardar um tempo inicial antes de começar a fazer refresh
  // Isso evita que múltiplas abas tentem fazer restore imediatamente ao abrir
  useEffect(() => {
    initialDelayRef.current = setTimeout(() => {
      setIsReady(true);
    }, INITIAL_DELAY);

    return () => {
      if (initialDelayRef.current) {
        clearTimeout(initialDelayRef.current);
      }
    };
  }, []);

  // Setup BroadcastChannel para coordenação entre abas
  useEffect(() => {
    if (!isReady) {
      return;
    }

    // Verificar suporte a BroadcastChannel
    if (typeof BroadcastChannel === 'undefined') {
      // Fallback: se não suportar, esta aba sempre será master
      setIsMasterTab(true);
      return;
    }

    const channel = new BroadcastChannel(SESSION_REFRESH_CHANNEL);
    channelRef.current = channel;

    // Tentar se tornar a aba master
    const becomeMaster = () => {
      channel.postMessage({ type: 'REQUEST_MASTER', tabId: Date.now() });
      // Se ninguém contestar em 200ms, vira master
      masterTimeoutRef.current = setTimeout(() => {
        if (!hasActiveMasterRef.current) {
          setIsMasterTab(true);
          hasActiveMasterRef.current = true;
          // Notificar outras abas que agora somos master
          channel.postMessage({ type: 'MASTER_ELECTED' });
        }
      }, 200);
    };

    channel.onmessage = (event) => {
      if (event.data.type === 'SESSION_REFRESHED') {
        // Outra aba fez refresh, não precisamos fazer nada
        // O backend já atualizou o TTL da sessão compartilhada
      } else if (event.data.type === 'REQUEST_MASTER') {
        // Outra aba quer ser master
        // Se já temos um master ativo, responder negando
        if (isMasterTab || hasActiveMasterRef.current) {
          channel.postMessage({ type: 'MASTER_EXISTS' });
        }
      } else if (event.data.type === 'MASTER_EXISTS') {
        // Outra aba já é master, cancelar nossa tentativa
        if (masterTimeoutRef.current) {
          clearTimeout(masterTimeoutRef.current);
          masterTimeoutRef.current = null;
        }
        setIsMasterTab(false);
        hasActiveMasterRef.current = true;
      } else if (event.data.type === 'MASTER_ELECTED') {
        // Outra aba foi eleita master
        if (!isMasterTab) {
          setIsMasterTab(false);
          hasActiveMasterRef.current = true;
          if (masterTimeoutRef.current) {
            clearTimeout(masterTimeoutRef.current);
            masterTimeoutRef.current = null;
          }
        }
      }
    };

    becomeMaster();

    return () => {
      if (masterTimeoutRef.current) {
        clearTimeout(masterTimeoutRef.current);
      }
      channel.close();
    };
  }, [isReady, isMasterTab]);

  // Callback memoizado para refresh da sessão
  // Solução #1: useCallback evita recriações desnecessárias que resetariam o intervalo
  const refreshSession = useCallback(() => {
    // Apenas a aba master faz refresh
    if (!isMasterTab) {
      return;
    }

    // Verificar se está pronto e tem sessão válida
    if (!isReady) {
      return;
    }

    if (!!session_info.intranet_session_id) {
      return;
    }

    if (!session || !session.client || !session.created_at) {
      return;
    }

    if (!session_info.client_id) {
      return;
    }

    const dto: RestoreSessionDto = {
      created_at: session.created_at,
      client_id: session.client.id,
      intranet_session_id: null,
      sso_id: session_info.sso_id,
      sso_token: session_info.sso_token,
      auth0_token: auth0_access_token
    };

    restore(dto)
      .then(() => {
        // Notificar outras abas que o refresh foi bem-sucedido
        if (channelRef.current) {
          channelRef.current.postMessage({ type: 'SESSION_REFRESHED' });
        }
      })
      .catch((error) => {
        // Apenas fazer logout se for realmente uma sessão expirada
        // Erros de rede ou temporários não devem deslogar
        const errorString = String(error);
        if (
          errorString.includes(ErrorCodes.ExpiredSession) ||
          errorString.includes(ErrorCodes.TokenExpired)
        ) {
          logout(error);
        }
        // Se não for erro de sessão expirada, apenas ignorar (pode ser erro de rede)
      });
  }, [
    isMasterTab,
    isReady,
    session_info.intranet_session_id,
    session,
    session_info.client_id,
    session_info.sso_id,
    session_info.sso_token,
    auth0_access_token,
    restore,
    logout
  ]);

  // Usar o callback memoizado no interval (só começa depois de isReady)
  // Passar um delay muito alto quando não está pronto, para efetivamente desabilitar
  useInterval(refreshSession, isReady ? DELAY : Number.MAX_SAFE_INTEGER);

  return null;
};
